import React from 'react';
import { whyChooseUs } from '../mockData';
import { Star, Shield, Clock, Leaf, Users, ThumbsUp } from 'lucide-react';

const iconMap = {
  0: Star,
  1: Clock,
  2: Shield,
  3: ThumbsUp,
  4: Leaf,
  5: Users
};

const WhyChooseUs = () => {
  return (
    <section className="bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-2 bg-[#f4e5c3]/30 rounded-full">
            <span className="text-[#b8962e] font-semibold">Zašto Odabrati Nas</span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-[#0f172a] mb-6 gold-underline">
            Vaš Pouzdani Građevinski Partner
          </h2>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Dekor Art gradnja nije samo građevinska tvrtka - mi smo vaš partner u stvaranju prostora 
            koji će trajati generacijama.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {whyChooseUs.map((item, index) => {
            const Icon = iconMap[index];
            return (
              <div 
                key={item.id}
                className="group p-8 rounded-2xl border-2 border-gray-100 hover:border-[#d4af37] transition-all hover:shadow-xl"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-[#d4af37] to-[#b8962e] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <Icon className="w-8 h-8 text-white" />
                </div>
                
                <h3 className="text-2xl font-bold text-[#0f172a] mb-4">
                  {item.title}
                </h3>
                
                <p className="text-gray-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>

        <div className="mt-16 bg-gradient-to-br from-[#0f172a] to-[#1e293b] rounded-3xl p-12 text-center text-white">
          <h3 className="text-3xl md:text-4xl font-bold mb-6">
            Spremni Za Početak Vašeg Projekta?
          </h3>
          <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
            Kontaktirajte nas danas i saznajte kako možemo pretvoriti vašu viziju u stvarnost.
          </p>
          <a 
            href="#contact" 
            onClick={(e) => {
              e.preventDefault();
              const element = document.querySelector('#contact');
              if (element) {
                const headerOffset = 80;
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
              }
            }}
            className="btn-primary inline-block cursor-pointer"
          >
            Započnimo Razgovor
          </a>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;